import { FIELD_LENGTHS } from '../../shared/field-lengths';

/** Wie `ObjectMappingDtos.NAME_PATTERN` im BE: Jedes dieser Zeichen liest der TCDL-Zerleger als Trenner. */
const VALID_NAME = /^(?!\/\/)[^\s\p{Cc}\p{Cf}\p{Z}.,"{}]+$/u;

/** Name einer Bibliothek oder eines Eintrags, wie das BE ihn annimmt. */
export function isValidObjectName(name: string): boolean {
  return name.length <= FIELD_LENGTHS.NAME_MAX && VALID_NAME.test(name);
}
